export default __webpack_public_path__ + "static/signer-c4dab90f1d7e081fd55faa04887b25d8.png";